export default __webpack_public_path__ + "assets/images/22037ac4e6f6a582cb161ea123c0c082.png";